import Overlay from "@components/Overlay/Overlay";

import useCampaignEmailStore from "@store/campaignStore";

interface ICampaignOverlayProperties {
  sendingCampaignStatus: string;
}

const CampaignOverlay = ({ sendingCampaignStatus }: ICampaignOverlayProperties) => {
  const { scheduledDateTime } = useCampaignEmailStore();
  let title = "Sending Campaign...";

  if (scheduledDateTime) {
    title = "Scheduling Campaign...";
  }

  return <Overlay caption="Please do not reload page." isVisible={sendingCampaignStatus === "pending"} title={title} />;
};

export default CampaignOverlay;
